import type { ConnectionVehicleDataState } from '@dh-io-globalelem/vehicle-data-store-connection';
import { initializeStore } from '@seamless/store';
export const connectionName = 'OWC_VEHICLE_DATA';

type ConnectionVehicleDataDispatchers = Awaited<
  ReturnType<typeof import('@dh-io-globalelem/vehicle-data-store-connection').getConnectionVehicleDataDispatchers>
>;

export async function setVehicleConfigurationId(vehicleId: string) {
  const seamlessStore = initializeStore();

  const dispatchers = await seamlessStore.getConnectionDispatchers<ConnectionVehicleDataDispatchers>(connectionName);
  dispatchers.setConfigurationId(vehicleId);
}

export function getVehicleDataStore(fn: (state: ConnectionVehicleDataState) => void) {
  const seamlessStore = initializeStore();

  seamlessStore.subscribe(connectionName, fn);
}
